// src/components/Navbar.js
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav } from 'react-bootstrap';
import { AuthContext } from '../context/AuthContext';
import '../Home.css';

function NavigationBar() {
  const { user } = useContext(AuthContext);

  return (
    <Navbar bg="dark" data-bs-theme="dark" expand="md">
      {/* Hamburger Menu */}
      <Navbar.Toggle aria-controls="navbar-nav" />

      {/* Collapsible Content */}
      <Navbar.Collapse id="navbar-nav">
        <Nav className="me-auto">
          {/* Brand */}
          <Navbar.Brand as={Link} to="/">
            compscichris
          </Navbar.Brand>

          {/* Navigation Links */}
          
          
          <Nav.Link as={Link} to="/" className="csc-nav-link">
            Notes
          </Nav.Link>
          <Nav.Link as={Link} to="/about" className="csc-nav-link">
            About
          </Nav.Link>
          <Nav.Link as={Link} to="/projects" className="csc-nav-link">
            Projects
          </Nav.Link>
          <Nav.Link as={Link} to="/chess" className="csc-nav-link">
            Game
          </Nav.Link>
          {user && (
            <Nav.Link as={Link} to="/contact" className="csc-nav-link">
              Contact
            </Nav.Link>
          )}
          {user ? (
            <Nav.Link as={Link} to="/logout" className="csc-nav-link">
              Logout
            </Nav.Link>
          ) : (
            <Nav.Link as={Link} to="/login" className="csc-nav-link">
              Login
            </Nav.Link>
          )}
          {user?.is_superuser && (
            <Nav.Link href="/admin" target="_blank" className="csc-nav-link">
              Admin
            </Nav.Link>
          )}
          
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default NavigationBar;
